import { render, staticRenderFns } from "./SendOfferModal.vue?vue&type=template&id=4b451aef&scoped=true&lang=pug"
import script from "./SendOfferModal.vue?vue&type=script&lang=js"
export * from "./SendOfferModal.vue?vue&type=script&lang=js"
import style0 from "./SendOfferModal.vue?vue&type=style&index=0&id=4b451aef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b451aef",
  null
  
)

export default component.exports